import React, { useState } from 'react';
import { showError, ucwords } from '../../utils';

import BlockButton from '../contacts/BlockButton';
import PriorityButton from '../contacts/PriorityButton';


import { ReactComponent as IconCall } from '../../assets/icons/call.svg';
import { ReactComponent as IconShare } from '../../assets/icons/share.svg';
import { ReactComponent as IconLoading } from '../../assets/icons/spinner.svg';
import { ReactComponent as IconEdit } from '../../assets/icons/edit.svg';
import { ReactComponent as IconDetails } from '../../assets/icons/info.svg';
import { useNavigate } from 'react-router-dom';

// Righe di contatti con espansione dettagli
const ContactListRow = ({ contact, setRawList, selectedList, handleSelectContact }) => {
    const navigate = useNavigate();
    const { id, numtel, cognome, nome, data_creazione, blocco, priorita} = contact;
   
    // Converti il cognome in lowercase con tutte le iniziali maiuscole
    let cognomeLower = ucwords(cognome);
    let nomeLower = ucwords(nome);
    

    return (
        <div className={`vista-row`} data-numero={numtel}>
            <div className="vista-row-info">
                <div className="sx">
                   
                    <input type="checkbox" className="select-checkbox" onChange={() => handleSelectContact(id)} checked={selectedList.includes(id)} disabled={selectedList.length == 1 && !selectedList.includes(id)}/>
                 
                    <div className="item sameline" style={{height: "50px"}}>
                        <span className="title text-trunc-ellipsis">{cognomeLower}&nbsp;<span className='title-v2'>{nomeLower}</span></span>
                        <span className="subtitle text-trunc-ellipsis">{numtel}</span>
                    </div>                  
                </div>
            </div>
        </div>
    );
}

export default ContactListRow;